import type { NodeUser } from 'models';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useNavigateToCreateChatWithUser = () => {
  const navigate = useNavigate();

  return useCallback(
    async (user: NodeUser) => {
      await navigate(routes.chat.create, {
        replace: true,
        state: {
          userToChat: { email: user.email, firstName: user.firstName, id: user._id, lastName: user.lastName },
        },
      });
    },
    [navigate],
  );
};
